import { Col } from 'antd';
import { FC } from 'react';

const FourItemColumn: FC = (props) => (
  <Col
    xs={{ span: 20, offset: 2 }}
    sm={{ span: 16, offset: 4 }}
    md={{ span: 12, offset: 1 }}
    lg={{ span: 6, offset: 0 }}
    {...props}
  />
);

export default FourItemColumn;
